<template>
	<div>
		<div
			class="w-full flex flex-col items-start justify-center sm:gap-9 gap-6  py-6"
		>
			<div class="w-full flex items-center justify-between">
				<p class="font-semibold text-2xl">
					Datos generales
				</p>

				<p 	
					class="only-dest font-medium text-sm cursor-pointer text-custom_gray hover:underline"
					@click="handleLeadClick(props.contactData)"				
				>
					Editar prospecto
				</p>
			</div>

			<div
				class="flex flex-col gap-2 text-base font-semibold"
			>
				<span>Nombre: <span class="font-normal">{{ fullName }}</span> </span>
				<span>Número de celular: <span class="font-normal">{{ props.contactData.phone }}</span> </span>
				<span>Correo electrónico: <span class="font-normal">{{ props.contactData.email }}</span> </span>
				<span>Tipo de contacto:
					<span 
						:class="[
							'inline-block font-medium text-xs px-2 py-1 rounded-md', 
							getBadgeBgForId(props.contactData.status), 
							getBadgeTextForId(props.contactData.status)
						]"
					>
						{{ currentStatus.name }}
					</span>
				</span>
				<p 	
					class="only-mob font-medium text-sm cursor-pointer text-custom_gray hover:underline"
					@click="handleLeadClick(props.contactData)"				
				>
					Editar prospecto
				</p>
			</div>

		</div>

	</div>
</template>
<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps({
  contactData: {
    type: Object,
    default: () => ({}),
    required: true
	},
	statuses: {
    type: Array,
    default: () => [
      { name: 'Nuevo', status: '1' },
      { name: 'En proceso', status: '2' },
      { name: 'Finalizado', status: '3' },
      { name: 'No aplica', status: '4' },
      { name: 'Perdido', status: '5' },
      { name: 'Descartado', status: '6' },
    ]
  }
});
const router = useRouter();

const badgeBgMap = {
  '1': 'bg-green-100',
  '2': 'bg-yellow-100',
  '3': 'bg-cyan-100',
  '4': 'bg-violet-100',
  '5': 'bg-orange-100',
  '6': 'bg-red-100',
}

const badgeTextMap = {
  '1': 'text-green-800',
  '2': 'text-yellow-800',
  '3': 'text-cyan-800',
  '4': 'text-violet-800',
  '5': 'text-orange-800',
  '6': 'text-red-800',
}

const getBadgeBgForId = (id) => {
  return badgeBgMap[String(id)] || 'bg-gray-100'
}

const getBadgeTextForId = (id) => {
  return badgeTextMap[String(id)] || 'text-gray-800'
}

const fullName = computed(() => {
  const { name = '', last_name = '', second_last_name = '' } = props.contactData;
  return `${name} ${last_name} ${second_last_name}`;
});

const currentStatus = computed(() => {
  return props.statuses.find(s => s.status === String(props.contactData.status)) || { name: 'Desconocido' };
});

function handleLeadClick(lead) {
  router.push({ name: 'leads-edit', params: { prospect_id: lead.id } });
}

</script>